<template>
  <div class="gym-page" id="top">

    <GymNavBar />

    <main>

    <!-- ══════════════════════════════════════════
         HERO
    ══════════════════════════════════════════ -->
    <section class="hero" ref="heroRef">
      <div class="hero-content hero-content-enter">
        <div class="hero-badge">
          <span class="badge-dot"></span>
          Cloudtec <strong>Gym</strong>
        </div>

        <h1>Διαχείριση γυμναστηρίου<br /><span class="accent">χωρίς χαρτιά, χωρίς χάος.</span></h1>

        <p>
          Σταμάτα να διαχειρίζεσαι το γυμναστήριό σου με χαρτιά και Excel. Κρατήσεις, μέλη, πληρωμές, mobile app — <strong>όλα σε ένα σύστημα.</strong>
        </p>

        <div class="hero-cta">
          <a class="cta-primary" href="https://ctgym.cloudtec.gr" target="_blank" rel="noopener">Ξεκίνα Δωρεάν</a>
          <a class="cta-secondary" href="#how">Δείτε Πώς Λειτουργεί ↓</a>
        </div>

        <p class="hero-microtrust">Χωρίς κάρτα &nbsp;·&nbsp; Setup σε 30 λεπτά &nbsp;·&nbsp; Ακύρωση οποτεδήποτε</p>

        <div class="hero-trust">
          <a class="trust-badge" href="https://play.google.com/store/apps/details?id=com.nvourlidas.ctgym" target="_blank" rel="noopener">
            <svg class="store-icon" viewBox="0 0 24 24" fill="currentColor"><path d="M3,20.5V3.5C3,2.91,3.34,2.39,3.84,2.15L13.69,12L3.84,21.85C3.34,21.6,3,21.09,3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08,20.75,11.5,20.75,12C20.75,12.5,20.5,12.92,20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/></svg>
            Google Play
          </a>
          <span class="trust-sep">·</span>
          <a class="trust-badge" href="https://apps.apple.com/gr/app/cloudtec-gym/id6757802948" target="_blank" rel="noopener">
            <svg class="store-icon" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
            App Store
          </a>
          <span class="trust-sep">·</span>
          <span class="trust-item">
            <svg class="check-icon" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>
            Χωρίς συμβόλαιο
          </span>
          <span class="trust-sep">·</span>
          <span class="trust-item">
            <svg class="check-icon" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>
            14 μέρες δωρεάν δοκιμή
          </span>
        </div>
      </div>

      <div class="hero-visual hero-visual-enter">
        <div class="hero-dashboard">
          <img :src="adminScreens[0].src" alt="Cloudtec Gym - Admin Dashboard" class="dashboard-img" />
        </div>
        <div class="hero-phone-overlay">
          <img class="phone phone-back" :src="phones[1]" alt="Cloudtec Gym - Κρατήσεις" />
          <img class="phone phone-front" :src="phones[0]" alt="Cloudtec Gym - Dashboard" />
        </div>
      </div>
    </section>

    <!-- ══════════════════════════════════════════
         PROOF BAR
    ══════════════════════════════════════════ -->
    <section class="proof-bar">
      <div class="container proof-bar-inner">
        <div class="proof-stat">
          <span class="proof-num" ref="statRef">50<span class="proof-plus">+</span></span>
          <span class="proof-label">γυμναστήρια μας εμπιστεύονται</span>
        </div>
        <div class="proof-divider"></div>
        <div class="proof-testimonials">
          <div v-for="t in testimonials" :key="t.name" class="proof-quote">
            <p class="proof-quote-text">"{{ t.q }}"</p>
            <span class="proof-quote-author">— {{ t.name }}, {{ t.city }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ══════════════════════════════════════════
         PAIN POINTS
    ══════════════════════════════════════════ -->
    <section class="pain-section">
      <div class="container sect-head">
        <div class="label-chip">Σου φαίνεται γνωστό;</div>
        <h2>Αναγνωρίζεις αυτές τις καταστάσεις;</h2>
        <p class="muted">Αν ναι, το Cloudtec Gym φτιάχτηκε ακριβώς για σένα.</p>
      </div>
      <div class="pain-grid">
        <div class="pain-card" v-for="p in painPoints" :key="p.pain">
          <div class="pain-before">
            <span class="pain-icon">✗</span>
            <span>{{ p.pain }}</span>
          </div>
          <div class="pain-arrow">→</div>
          <div class="pain-after">
            <span class="pain-icon pain-icon--green">✓</span>
            <span>{{ p.fix }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ══════════════════════════════════════════
         FOR WHOM
    ══════════════════════════════════════════ -->
    <section class="whom-section">
      <div class="container sect-head">
        <h2>Για ποιους είναι;</h2>
        <p class="muted">Ιδανικό για κάθε χώρο γυμναστικής, είτε μικρό είτε μεγάλο.</p>
      </div>

      <div class="whom-grid">
        <div class="whom-card">
          <div class="whom-emoji">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14.4 14.4 9.6 9.6"/><path d="M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z"/><path d="m2.929 12.485 1.414 1.414"/><path d="M7.071 7.071 8.485 8.485"/>
            </svg>
          </div>
          <div class="whom-body">
            <div class="whom-title">Γυμναστήρια</div>
            <div class="whom-desc">Διαχείριση μελών, συνδρομών, τμημάτων και εγκαταστάσεων σε ένα σύστημα.</div>
          </div>
        </div>
        <div class="whom-card">
          <div class="whom-emoji">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2"/><path d="M9.6 4.6A2 2 0 1 1 11 8H2"/><path d="M12.6 19.4A2 2 0 1 0 14 16H2"/>
            </svg>
          </div>
          <div class="whom-body">
            <div class="whom-title">Studios (Yoga, Pilates, CrossFit)</div>
            <div class="whom-desc">Κρατήσεις θέσεων, online προγράμματα, αυτοματοποιημένες ειδοποιήσεις.</div>
          </div>
        </div>
        <div class="whom-card">
          <div class="whom-emoji">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><polyline points="16 11 18 13 22 9"/>
            </svg>
          </div>
          <div class="whom-body">
            <div class="whom-title">Personal Trainers</div>
            <div class="whom-desc">Ερωτηματολόγια, workout templates, tracking προόδου και επικοινωνία με μέλη.</div>
          </div>
        </div>
        <div class="whom-card">
          <div class="whom-emoji">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>
            </svg>
          </div>
          <div class="whom-body">
            <div class="whom-title">Σχολές Χορού</div>
            <div class="whom-desc">Διαχείριση τμημάτων, εγγραφές μαθητών και πρόγραμμα μαθημάτων σε μία πλατφόρμα.</div>
          </div>
        </div>
        <div class="whom-card">
          <div class="whom-emoji">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="m6.5 6.5 11 11"/><path d="m21 21-1-1"/><path d="m3 3 1 1"/><path d="m18 22 4-4"/><path d="m2 6 4-4"/><path d="m3 22 7.5-7.5"/><path d="m14.5 3.5 4 4"/>
            </svg>
          </div>
          <div class="whom-body">
            <div class="whom-title">Πολεμικές Τέχνες</div>
            <div class="whom-desc">Παρακολούθηση επιπέδων, κρατήσεις και ωρολόγια προγράμματα για κάθε πειθαρχία.</div>
          </div>
        </div>
        <div class="whom-card">
          <div class="whom-emoji">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/><path d="M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27"/>
            </svg>
          </div>
          <div class="whom-body">
            <div class="whom-title">Φυσικοθεραπευτήρια</div>
            <div class="whom-desc">Διαχείριση ραντεβού, ιστορικό θεραπείας ανά ασθενή και παρακολούθηση προόδου αποκατάστασης.</div>
          </div>
        </div>
      </div>

      <div class="container sect-foot">
        <p class="muted">Κατασκευασμένο από επαγγελματίες του χώρου — για επαγγελματίες του χώρου.</p>
        <a class="sect-link" href="https://ctgym.cloudtec.gr" target="_blank" rel="noopener">Ξεκινήστε Δωρεάν →</a>
      </div>
    </section>

    <!-- ══════════════════════════════════════════
         FEATURES
    ══════════════════════════════════════════ -->
    <section class="features-section" id="features">
      <!-- Title above -->
      <div class="container feat-head">
        <div class="label-chip">Χαρακτηριστικά</div>
        <h2>Ό,τι χρειάζεσαι, έτοιμο.</h2>
        <p class="muted">Από τη διαχείριση μελών έως push notifications — όλα σε μία πλατφόρμα.</p>
      </div>

      <!-- Full-width grid -->
      <div class="features-grid">
        <div v-for="f in features" :key="f.key" class="feature-card">
          <div class="feature-icon" v-html="f.icon"></div>
          <div class="feature-body">
            <div class="feature-label">{{ f.label }}</div>
            <div class="feature-desc">{{ f.desc }}</div>
          </div>
        </div>
      </div>

      <!-- Note below -->
      <div class="container feat-foot">
        <p class="muted">Όλα ενσωματωμένα. Χωρίς επιπλέον software, χωρίς integrations που σπάνε.</p>
        <router-link class="feat-foot-link" to="/contact">Μιλήστε μαζί μας →</router-link>
      </div>
    </section>

    <!-- ══════════════════════════════════════════
         SCREENSHOTS STRIP
    ══════════════════════════════════════════ -->
    <section class="section screenshots-section">
      <div class="container">
        <div class="section-head">
          <div class="label-chip">Screens</div>
          <h2>Δείτε το σε δράση</h2>
          <p class="muted">Native iOS & Android app για τα μέλη και πλήρης web admin panel.</p>
        </div>
        <div class="screens-tabs">
          <button class="screens-tab" :class="{ active: screensTab === 'app' }" @click="screensTab = 'app'">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="7" height="12" x="8" y="2" rx="1"/><path d="M17 6H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z"/><path d="M12 18v4"/><path d="M8 22h8"/></svg>
            Mobile App
          </button>
          <button class="screens-tab" :class="{ active: screensTab === 'admin' }" @click="screensTab = 'admin'">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="20" height="14" x="2" y="3" rx="2"/><path d="M8 21h8"/><path d="M12 17v4"/></svg>
            Admin Panel
          </button>
        </div>
      </div>

      <!-- Mobile app screenshots -->
      <div v-show="screensTab === 'app'" class="screenshots-scroll">
        <div class="screenshots-track">
          <div v-for="(img, i) in phones" :key="i" class="screenshot-item">
            <img :src="img" :alt="`Cloudtec Gym screen ${i + 1}`" />
          </div>
        </div>
      </div>

      <!-- Admin panel carousel -->
      <div v-show="screensTab === 'admin'" class="admin-carousel">
        <button class="carousel-arrow carousel-arrow--prev" @click="adminPrev" aria-label="Προηγούμενο">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
        </button>

        <div class="carousel-viewport">
          <transition name="carousel-fade" mode="out-in">
            <div class="carousel-slide" :key="adminIdx">
              <img :src="adminScreens[adminIdx].src" :alt="adminScreens[adminIdx].label" class="carousel-img" />
              <span class="carousel-label">{{ adminScreens[adminIdx].label }}</span>
            </div>
          </transition>
        </div>

        <button class="carousel-arrow carousel-arrow--next" @click="adminNext" aria-label="Επόμενο">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>
        </button>

        <div class="carousel-dots">
          <button v-for="(s, i) in adminScreens" :key="i"
                  class="carousel-dot" :class="{ active: i === adminIdx }"
                  @click="adminIdx = i" :aria-label="s.label" />
        </div>
      </div>

      <div class="container">
        <div class="app-store-row">
          <a class="store-btn" href="https://play.google.com/store/apps/details?id=com.nvourlidas.ctgym" target="_blank" rel="noopener">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M3,20.5V3.5C3,2.91,3.34,2.39,3.84,2.15L13.69,12L3.84,21.85C3.34,21.6,3,21.09,3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08,20.75,11.5,20.75,12C20.75,12.5,20.5,12.92,20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/></svg>
            Google Play
          </a>
          <a class="store-btn" href="https://apps.apple.com/gr/app/cloudtec-gym/id6757802948" target="_blank" rel="noopener">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
            App Store
          </a>
          <span class="store-note muted">Διαθέσιμο για Android & iOS</span>
        </div>
      </div>
    </section>

    <!-- ══════════════════════════════════════════
         TESTIMONIALS
    ══════════════════════════════════════════ -->
    <section class="testimonials-section">
      <div class="container sect-head">
        <div class="label-chip">Τι λένε οι χρήστες μας</div>
        <h2>Γυμναστήρια που ήδη μας εμπιστεύονται</h2>
      </div>
      <div class="testimonials-grid">
        <div v-for="t in testimonialCards" :key="t.name" class="testi-card">
          <div class="testi-stars">
            <svg v-for="i in 5" :key="i" width="14" height="14" viewBox="0 0 24 24" fill="#FFC947"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          </div>
          <p class="testi-text">"{{ t.text }}"</p>
          <div class="testi-author">
            <div class="testi-avatar">{{ t.name[0] }}</div>
            <div>
              <div class="testi-name">{{ t.name }}</div>
              <div class="testi-meta muted">{{ t.role }} · {{ t.city }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ══════════════════════════════════════════
         HOW IT WORKS
    ══════════════════════════════════════════ -->
    <section class="how-section" id="how">
      <div class="container sect-head">
        <h2>Πώς ξεκινάς</h2>
        <p class="muted">Σε 3 βήματα από την εγγραφή ως το πρώτο check-in.</p>
      </div>

      <div class="how-grid">
        <div class="how-card">
          <div class="step-num">01</div>
          <div class="t">Εγγραφή & ρύθμιση</div>
          <div class="m">Δημιουργείς λογαριασμό, ορίζεις τμήματα, συνδρομές και ώρες λειτουργίας.</div>
        </div>
        <div class="how-card">
          <div class="step-num">02</div>
          <div class="t">Πρόσκληση μελών</div>
          <div class="m">Τα μέλη σου κατεβάζουν το app, συνδέονται και κάνουν κρατήσεις μόνα τους.</div>
        </div>
        <div class="how-card">
          <div class="step-num">03</div>
          <div class="t">Διαχείριση & ανάπτυξη</div>
          <div class="m">Παρακολουθείς analytics, στέλνεις campaigns και αναπτύσσεις τη βάση μελών σου.</div>
        </div>
      </div>

      <div class="container sect-foot">
        <p class="muted">Ολόκληρη η ρύθμιση γίνεται σε λιγότερο από 30 λεπτά.</p>
        <a class="sect-link" href="https://ctgym.cloudtec.gr" target="_blank" rel="noopener">Ξεκίνα τώρα →</a>
      </div>
    </section>

    <!-- ══════════════════════════════════════════
         PRICING
    ══════════════════════════════════════════ -->
    <section class="pricing-section" id="pricing" ref="pricingRef">
      <div class="container sect-head">
        <div class="label-chip">Τιμολόγηση</div>
        <h2>Απλά πλάνα, χωρίς εκπλήξεις</h2>
        <p class="muted">Μηνιαία χρέωση. Ακύρωση οποτεδήποτε. Ξεκίνα δωρεάν.</p>
      </div>

      <div class="container">
        <!-- Plan cards -->
        <div class="plans-grid"
             :class="{ 'plans-visible': pricingVisible, 'plans-animated': pricingAnimated }">
          <div v-for="(plan, idx) in plans" :key="plan.key"
               :class="['plan-card', plan.popular ? 'plan-popular' : '']"
               :style="{ transitionDelay: pricingAnimated ? '0ms' : `${idx * 130}ms` }">

            <div v-if="plan.popular" class="popular-badge">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
              Πιο Δημοφιλές
            </div>

            <div class="plan-top">
              <div class="plan-name-row">
                <span class="plan-icon" v-html="plan.icon"></span>
                <span class="plan-name">{{ plan.name }}</span>
              </div>
              <div class="plan-price">
                <span class="price-val">{{ plan.price }}</span>
                <span class="price-per">/ μήνα</span>
              </div>
              <p class="plan-tagline muted">{{ plan.tagline }}</p>
            </div>

            <div class="plan-divider"></div>

            <!-- Limits -->
            <div class="plan-limits">
              <div v-for="lim in plan.limits" :key="lim.label" class="limit-item">
                <span class="limit-label">{{ lim.label }}</span>
                <span class="limit-val">{{ lim.val }}</span>
              </div>
            </div>

            <!-- Features -->
            <ul class="plan-features">
              <li v-for="feat in plan.features" :key="feat.label"
                  :class="['plan-feat', feat.included ? '' : 'feat-off']">
                <span class="feat-check">
                  <svg v-if="feat.included" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/></svg>
                </span>
                {{ feat.label }}
              </li>
            </ul>

            <div class="plan-cta-wrap">
              <a href="https://ctgym.cloudtec.gr" target="_blank" rel="noopener"
                :class="['plan-cta', plan.popular ? 'plan-cta-primary' : 'plan-cta-secondary']">
                {{ plan.cta }}
              </a>
              <p class="plan-note muted">{{ plan.note }}</p>
            </div>
          </div>
        </div>

        <!-- Comparison table -->
        <div class="compare-wrap">
          <button class="compare-toggle" @click="showCompare = !showCompare" :aria-expanded="showCompare">
            <span>{{ showCompare ? 'Απόκρυψη' : 'Πλήρης σύγκριση χαρακτηριστικών' }}</span>
            <svg class="toggle-arrow" :class="{ open: showCompare }" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
          </button>

          <div v-if="showCompare" class="compare-table-wrap">
            <table class="compare-table">
              <thead>
                <tr>
                  <th class="feat-col">Χαρακτηριστικό</th>
                  <th v-for="p in plans" :key="p.key" :class="['plan-col', p.popular ? 'col-popular' : '']">
                    {{ p.name }}
                    <div class="th-price">{{ p.price }}<span>/μήνα</span></div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="section-row">
                  <td colspan="4">Όρια πλάνου</td>
                </tr>
                <tr v-for="row in limitRows" :key="row.key">
                  <td class="feat-col">
                    <span class="row-label">{{ row.label }}</span>
                    <span v-if="row.hint" class="row-hint muted">{{ row.hint }}</span>
                  </td>
                  <td v-for="p in plans" :key="p.key" :class="p.popular ? 'col-popular' : ''">
                    <span class="limit-badge">{{ p.limitValues[row.key] }}</span>
                  </td>
                </tr>

                <tr class="section-row">
                  <td colspan="4">Χαρακτηριστικά</td>
                </tr>
                <tr v-for="row in featureRows" :key="row.key">
                  <td class="feat-col">
                    <span class="row-label">{{ row.label }}</span>
                    <span v-if="row.hint" class="row-hint muted">{{ row.hint }}</span>
                  </td>
                  <td v-for="p in plans" :key="p.key" :class="p.popular ? 'col-popular' : ''">
                    <span v-if="p.featureValues[row.key]" class="cell-yes">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                    </span>
                    <span v-else class="cell-no">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/></svg>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="sect-foot">
          <p class="muted">Όλες οι τιμές είναι μηνιαίες. Η ενεργοποίηση γίνεται αυτόματα μετά την πληρωμή.</p>
          <router-link class="sect-link" to="/contact">Μιλήστε μαζί μας →</router-link>
        </div>
      </div>
    </section>

    <!-- ══════════════════════════════════════════
         TRUST / FAQ
    ══════════════════════════════════════════ -->
    <section class="faq-section" id="faq">
      <div class="container sect-head">
        <h2>Συχνές ερωτήσεις</h2>
        <p class="muted">Ό,τι θέλεις να ξέρεις πριν ξεκινήσεις.</p>
      </div>

      <div class="container faq-accordion">
        <div v-for="(faq, i) in faqs" :key="faq.q" class="faq-item" :class="{ open: openFaq === i }" @click="openFaq = openFaq === i ? null : i">
          <div class="faq-header">
            <span class="faq-q">{{ faq.q }}</span>
            <svg class="faq-chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
          </div>
          <div class="faq-body">
            <p class="faq-a muted">{{ faq.a }}</p>
          </div>
        </div>
      </div>

      <div class="container sect-foot">
        <p class="muted">Δεν βρήκες απάντηση; Επικοινώνησε μαζί μας.</p>
        <router-link class="sect-link" to="/contact">Επικοινωνία →</router-link>
      </div>
    </section>

    <!-- ══════════════════════════════════════════
         CTA BOTTOM
    ══════════════════════════════════════════ -->
    <section class="cta">
      <div class="container cta-inner">
        <div class="cta-text">
          <p class="cta-proof-line">Γίνε μέλος 50+ γυμναστηρίων που ήδη χρησιμοποιούν Cloudtec Gym</p>
          <h2>Έτοιμος να σταματήσεις να χάνεις χρόνο;</h2>
          <p class="muted">Ξεκίνα δωρεάν σήμερα — χωρίς κάρτα, χωρίς δεσμεύσεις.</p>
        </div>
        <div class="cta-btns">
          <a class="cta-primary big cta-pulse" href="https://ctgym.cloudtec.gr" target="_blank" rel="noopener">Ξεκίνα Δωρεάν Σήμερα</a>
          <router-link class="cta-secondary" to="/contact">Μιλήστε μαζί μας</router-link>
        </div>
      </div>
    </section>

    <!-- ══════════════════════════════════════════
         GYM FOOTER
    ══════════════════════════════════════════ -->
    </main>

    <footer class="gym-footer">
      <div class="gym-footer-main">

        <div class="gym-footer-brand">
          <div class="gym-footer-logo">
            <img class="gym-logo-img" src="@/assets/CTGYM.YELLOW 1080x1080.svg" alt="Cloudtec Gym logo" />
            <span>Cloudtec <strong>Gym</strong></span>
          </div>
          <p class="gym-footer-tagline">Ολοκληρωμένη πλατφόρμα διαχείρισης γυμναστηρίου για επαγγελματίες.</p>
          <a class="gym-footer-appstore-btn"
             href="https://play.google.com/store/apps/details?id=com.nvourlidas.ctgym"
             target="_blank" rel="noopener">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3,20.5V3.5C3,2.91,3.34,2.39,3.84,2.15L13.69,12L3.84,21.85C3.34,21.6,3,21.09,3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08,20.75,11.5,20.75,12C20.75,12.5,20.5,12.92,20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
            </svg>
            Google Play
          </a>
          <a class="gym-footer-appstore-btn"
             href="https://apps.apple.com/gr/app/cloudtec-gym/id6757802948"
             target="_blank" rel="noopener">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            App Store
          </a>
        </div>

        <div class="gym-footer-col">
          <div class="gym-footer-col-title">Πλατφόρμα</div>
          <a href="#features">Χαρακτηριστικά</a>
          <router-link to="/products/cloudtec-gym/how-it-works">Πώς Λειτουργεί</router-link>
          <a href="#pricing">Τιμολόγηση</a>
          <a href="#faq">FAQ</a>
        </div>

        <div class="gym-footer-col">
          <div class="gym-footer-col-title">Επικοινωνία</div>
          <a href="mailto:info@cloudtec.gr">info@cloudtec.gr</a>
          <a href="tel:+306985786121">+30 698 578 6121</a>
          <router-link to="/contact">Φόρμα επικοινωνίας</router-link>
        </div>

        <div class="gym-footer-col">
          <div class="gym-footer-col-title">Νομικά</div>
          <router-link to="/products/cloudtec-gym/terms">Όροι Χρήσης</router-link>
          <router-link to="/products/cloudtec-gym/privacy">Πολιτική Απορρήτου</router-link>
        </div>
      </div>

      <div class="gym-footer-bottom">
        <p>&copy; {{ currentYear }} Cloudtec Gym. Powered by <router-link to="/">CloudTec</router-link>.</p>
        <a class="gym-footer-top" href="#top">Πάνω ↑</a>
      </div>
    </footer>


    <!-- Sticky mobile CTA -->
    <transition name="slide-up">
      <div v-if="showMobileCTA" class="mobile-cta-bar">
        <a href="https://ctgym.cloudtec.gr" target="_blank" rel="noopener" class="mobile-cta-btn">Ξεκίνα Δωρεάν — Χωρίς Κάρτα</a>
      </div>
    </transition>

  </div>
</template>


<script>
import dashImg        from '@/assets/phone/AppStore.Dashboard.png';
import bookImg        from '@/assets/phone/AppStore.Bookings.png';
import analyticsImg   from '@/assets/phone/AppStore.SessionsAnalytics.png';
import trackingImg    from '@/assets/phone/AppStore.SessionsTracking.png';
import profileImg     from '@/assets/phone/AppStore.ProfileAnalytics.png';

import adminDashImg     from '@/assets/CloudtecGym/Dashboard_widgets.png';
import adminMembersImg  from '@/assets/CloudtecGym/Members_list.png';
import adminBookingsImg from '@/assets/CloudtecGym/Bookings.png';
import adminFinancesImg from '@/assets/CloudtecGym/Finances.png';
import adminQRImg       from '@/assets/CloudtecGym/QR_Checkin.png';
import adminSessionsImg from '@/assets/CloudtecGym/Programm_Sessions.png';
import adminMemberImg   from '@/assets/CloudtecGym/Member_details.png';
import adminPlansImg    from '@/assets/CloudtecGym/Membership_plans.png';
import GymNavBar from '@/components/Products/CloudtecGym/GymNavBar.vue';

export default {
  name: 'CloudtecGym',
  components: { GymNavBar },

  data() {
    return {
      showCompare: false,
      pricingVisible: false,
      pricingAnimated: false,
      currentYear: new Date().getFullYear(),
      openFaq: null,
      showMobileCTA: false,

      testimonials: [
        { name: 'Νίκος Π.', city: 'Αθήνα', q: 'Εξοικονόμησα 5 ώρες την εβδομάδα που έχανα στη διαχείριση.' },
        { name: 'Μαρία Κ.', city: 'Θεσσαλονίκη', q: 'Τα μέλη μου αγαπούν το app. Μηδέν τηλεφώνατα για κρατήσεις.' },
        { name: 'Γιώργης Δ.', city: 'Πάτρα', q: 'Setup σε 20 λεπτά, μετά λειτουργεί μόνο του.' },
      ],

      testimonialCards: [
        { name: 'Νίκος Παπαδόπουλος', role: 'Ιδιοκτήτης γυμναστηρίου', city: 'Αθήνα', text: 'Πριν το Cloudtec Gym έχανα ώρες κάθε εβδομάδα σε Excel και τηλεφωνήματα. Τώρα τα πάντα γίνονται αυτόματα. Τα μέλη μου κάνουν κράτηση μόνα τους από το app.' },
        { name: 'Μαρία Κωνσταντίνου', role: 'Studio Yoga & Pilates', city: 'Θεσσαλονίκη', text: 'Το καλύτερο που έκανα για το studio μου. Η διαχείριση παρουσιών και πληρωμών έγινε παιχνιδάκι. Ιδιαίτερα το QR check-in είναι απίστευτα βολικό.' },
        { name: 'Γιώργης Δημητρίου', role: 'CrossFit Box', city: 'Πάτρα', text: 'Ξεκίνησα με το Free πλάνο για να δοκιμάσω. Σε μία εβδομάδα αναβάθμισα σε Pro. Δεν το μετανιώνω καθόλου — τα analytics μόνα τους αξίζουν την επένδυση.' },
      ],

      painPoints: [
        { pain: 'Τα μέλη σε παίρνουν τηλέφωνο για να κάνουν κράτηση', fix: 'Κάνουν κράτηση μόνα τους από το app σε 30 δευτερόλεπτα' },
        { pain: 'Χάνεις χρόνο ψάχνοντας ποιος έχει πληρώσει', fix: 'Βλέπεις όλες τις πληρωμές και οφειλές σε ένα dashboard' },
        { pain: 'Δεν ξέρεις πόσα έσοδα έχεις αυτόν τον μήνα', fix: 'Analytics σε πραγματικό χρόνο — έσοδα, παρουσίες, νέα μέλη' },
        { pain: 'Το πρόγραμμα αλλάζει και πρέπει να ειδοποιήσεις όλους χειροκίνητα', fix: 'Push notifications σε όλα τα μέλη με ένα κλικ' },
      ],

      screensTab: 'app',
      adminIdx: 0,
      phones: [dashImg, bookImg, analyticsImg, trackingImg, profileImg],
      adminScreens: [
        { src: adminDashImg,     label: 'Dashboard' },
        { src: adminMembersImg,  label: 'Μέλη' },
        { src: adminBookingsImg, label: 'Κρατήσεις' },
        { src: adminMemberImg,   label: 'Προφίλ Μέλους' },
        { src: adminFinancesImg, label: 'Οικονομικά' },
        { src: adminSessionsImg, label: 'Προγράμματα' },
        { src: adminPlansImg,    label: 'Πλάνα Συνδρομών' },
        { src: adminQRImg,       label: 'QR Check-in' },
      ],

      features: [
        { key: 'admin',    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect width="20" height="14" x="2" y="3" rx="2"/><path d="M8 21h8"/><path d="M12 17v4"/></svg>',                                                                                                                                                                                      label: 'Admin Panel',              desc: 'Πλήρης διαχείριση γυμναστηρίου από οποιαδήποτε συσκευή.' },
        { key: 'members',  icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',                                                                                                             label: 'Διαχείριση Μελών',          desc: 'Προφίλ, ιστορικό, σημειώσεις και παρακολούθηση κάθε μέλους.' },
        { key: 'bookings', icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8 2v4"/><path d="M16 2v4"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18"/></svg>',                                                                                                                                                                 label: 'Κρατήσεις & Check-in',      desc: 'Online κρατήσεις, QR check-in και διαχείριση παρουσιών.' },
        { key: 'classes',  icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>',                                                                                                                                                                                                                                       label: 'Classes & Προγράμματα',     desc: 'Δημιουργία τμημάτων, ωραρίων και ορίων χωρητικότητας.' },
        { key: 'workouts', icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect width="8" height="4" x="8" y="2" rx="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="M12 11h4"/><path d="M12 16h4"/><path d="M8 11h.01"/><path d="M8 16h.01"/></svg>',                                               label: 'Workout Templates',          desc: 'Σχεδιασμός και ανάθεση προγραμμάτων γυμναστικής ανά μέλος.' },
        { key: 'quest',    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><line x1="16" x2="8" y1="13" y2="13"/><line x1="16" x2="8" y1="17" y2="17"/><line x1="10" x2="8" y1="9" y2="9"/></svg>',                               label: 'Ερωτηματολόγια',            desc: 'Αξιολόγηση στόχων, παρακολούθηση προόδου και intake forms.' },
        { key: 'email',    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>',                                                                                                                                                                     label: 'Email Campaigns',            desc: 'Αποστολή newsletter και ενημερώσεων στα μέλη σου.' },
        { key: 'push',     icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>',                                                                                                                                                                           label: 'Push Notifications',         desc: 'Ειδοποιήσεις για κρατήσεις, προσφορές και νέα.' },
        { key: 'exports',  icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="18" x2="18" y1="20" y2="10"/><line x1="12" x2="12" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="14"/></svg>',                                                                                                                                                      label: 'Export Excel / PDF',         desc: 'Εξαγωγή δεδομένων μελών, πληρωμών και παρουσιών.' },
        { key: 'theme',    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/><circle cx="17.5" cy="10.5" r=".5" fill="currentColor"/><circle cx="8.5" cy="7.5" r=".5" fill="currentColor"/><circle cx="6.5" cy="12.5" r=".5" fill="currentColor"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/></svg>', label: 'Custom Theme & Logo',        desc: 'Το app με τα χρώματα και το brand του γυμναστηρίου σου.' },
        { key: 'mobile',   icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect width="14" height="20" x="5" y="2" rx="2"/><path d="M12 18h.01"/></svg>',                                                                                                                                                                                                    label: 'Mobile App για Μέλη',        desc: 'Native iOS & Android app — διαθέσιμο στα stores.' },
        { key: 'support',  icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',                                                                                                                                                                                                                  label: 'Προτεραιότητα Υποστήριξης', desc: 'Άμεση βοήθεια για επείγοντα ζητήματα και ερωτήματα.' },
      ],

      plans: [
        {
          key: 'free',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect width="20" height="5" x="2" y="7" rx="2"/><line x1="12" x2="12" y1="22" y2="7"/><path d="M7 7H4.5A2.5 2.5 0 0 1 7 4.5C8.5 4.5 10.5 5.5 12 7"/><path d="M17 7h2.5A2.5 2.5 0 0 0 17 4.5C15.5 4.5 13.5 5.5 12 7"/></svg>',
          name: 'Free',
          price: '€0',
          popular: false,
          tagline: 'Βασική πρόσβαση για δοκιμή.',
          cta: 'Ξεκίνα Δωρεάν',
          note: 'Χωρίς κάρτα.',
          limits: [
            { label: 'Μέλη',      val: '10'  },
            { label: 'Τμήματα',   val: '3'   },
            { label: 'Συνδρομές', val: '2'   },
            { label: 'Πρόγραμμα', val: '7μ'  },
          ],
          limitValues: { members: '10', classes: '3', memberships: '2', schedule: '7 μέρες' },
          featureValues: {
            admin: true, members: true, bookings: true, classes: true,
            workouts: false, questionnaires: false, email: false, push: false,
            exports: false, theme: false, mobile: false, support: false,
          },
          features: [
            { label: 'Admin Panel',           included: true  },
            { label: 'Mobile App',            included: true },
            { label: 'Διαχείριση μελών',      included: true  },
            { label: 'Κρατήσεις & Check-in',  included: true  },
            { label: 'Τμήματα & Προγράμματα', included: true  },
            { label: 'Workout Templates',     included: false },
            { label: 'Email Campaigns',       included: false },
            { label: 'Push Notifications',    included: false },
            
          ],
        },
        {
          key: 'starter',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
          name: 'Starter',
          price: '€19.99',
          popular: false,
          tagline: 'Ιδανικό για να ξεκινήσεις οργανωμένα.',
          cta: 'Ξεκίνα με Starter',
          note: '14 ημέρες δωρεάν δοκιμή.',
          limits: [
            { label: 'Μέλη',      val: '60'  },
            { label: 'Τμήματα',   val: '10'  },
            { label: 'Συνδρομές', val: '10'  },
            { label: 'Πρόγραμμα', val: '90μ' },
          ],
          limitValues: { members: '60', classes: '10', memberships: '10', schedule: '90 μέρες' },
          featureValues: {
            admin: true, members: true, bookings: true, classes: true,
            workouts: true, questionnaires: true, email: true, push: true,
            exports: false, theme: false, mobile: true, support: false,
          },
          features: [
            { label: 'Admin Panel',           included: true  },
            { label: 'Mobile App',            included: true  },
            { label: 'Διαχείριση μελών',      included: true  },
            { label: 'Κρατήσεις & Check-in',  included: true  },
            { label: 'Τμήματα & Προγράμματα', included: true  },
            { label: 'Workout Templates',     included: true  },
            { label: 'Email Campaigns',       included: true  },
            { label: 'Push Notifications',    included: true  }, 
          ],
        },
        {
          key: 'pro',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m2 4 3 12h14l3-12-6 7-4-7-4 7-6-7z"/><path d="M5 20h14"/></svg>',
          name: 'Pro',
          price: '€29.99',
          popular: true,
          tagline: 'Όλα τα Pro εργαλεία για ανάπτυξη & marketing.',
          cta: 'Αναβάθμισε σε Pro',
          note: '14 ημέρες δωρεάν δοκιμή.',
          limits: [
            { label: 'Μέλη',      val: '∞'  },
            { label: 'Τμήματα',   val: '∞'  },
            { label: 'Συνδρομές', val: '∞'  },
            { label: 'Πρόγραμμα', val: '∞'  },
          ],
          limitValues: { members: '∞', classes: '∞', memberships: '∞', schedule: '∞' },
          featureValues: {
            admin: true, members: true, bookings: true, classes: true,
            workouts: true, questionnaires: true, email: true, push: true,
            exports: true, theme: true, mobile: true, support: true,
          },
          features: [
            { label: 'Admin Panel',                included: true },
            { label: 'Mobile App',                 included: true },            
            { label: 'Διαχείριση μελών',           included: true },
            { label: 'Κρατήσεις & Check-in',       included: true },
            { label: 'Τμήματα & Προγράμματα',      included: true },
            { label: 'Workout Templates',          included: true },
            { label: 'Email Campaigns',            included: true },
            { label: 'Push Notifications',         included: true },
            { label: 'Export Excel / PDF',         included: true },
            { label: 'Custom Theme & Logo',        included: true },
            { label: 'Προτεραιότητα υποστήριξης', included: true },
          ],
        },
      ],

      limitRows: [
        { key: 'members',     label: 'Μέλη',                               hint: 'Μέγιστος αριθμός ενεργών μελών'     },
        { key: 'classes',     label: 'Τμήματα',                            hint: 'Μέγιστος αριθμός τμημάτων'           },
        { key: 'memberships', label: 'Συνδρομές',                          hint: 'Πακέτα / τύποι συνδρομών'            },
        { key: 'schedule',    label: 'Προγραμματισμός τμημάτων (ημέρες)',  hint: 'Πόσες μέρες μπροστά'                 },
      ],

      featureRows: [
        { key: 'admin',          label: 'Admin Panel πρόσβαση'                                       },
        { key: 'members',        label: 'Διαχείριση μελών'                                           },
        { key: 'bookings',       label: 'Κρατήσεις & Check-in'                                       },
        { key: 'classes',        label: 'Τμήματα & Προγράμματα'                                      },
        { key: 'workouts',       label: 'Workout Templates'                                          },
        { key: 'questionnaires', label: 'Ερωτηματολόγια'                                             },
        { key: 'email',          label: 'Email Campaigns'                                            },
        { key: 'push',           label: 'Push Notifications'                                         },
        { key: 'exports',        label: 'Export Excel / PDF'                                         },
        { key: 'theme',          label: 'Custom Theme & Logo', hint: 'Χρώματα / branding στο mobile' },
        { key: 'mobile',         label: 'Mobile App για μέλη'                                        },
        { key: 'support',        label: 'Προτεραιότητα υποστήριξης'                                  },
      ],

      faqs: [
        {
          q: 'Χρειάζομαι κάρτα για να ξεκινήσω;',
          a: 'Όχι. Το Free πλάνο είναι δωρεάν για πάντα. Για τα Starter/Pro, ξεκινάς με 14 μέρες δωρεάν δοκιμή χωρίς κάρτα.',
        },
        {
          q: 'Πώς γίνεται η πληρωμή;',
          a: 'Μέσω του ασφαλούς checkout της Viva. Η ενεργοποίηση είναι αυτόματη μετά την πληρωμή.',
        },
        {
          q: 'Μπορώ να ακυρώσω οποτεδήποτε;',
          a: 'Ναι, χωρίς κόστη ακύρωσης ή ελάχιστη διάρκεια. Το πλάνο σου παραμένει ενεργό ως το τέλος της τρέχουσας περιόδου.',
        },
        {
          q: 'Υπάρχει mobile app;',
          a: 'Ναι. Το Cloudtec Gym έχει native app για iOS (App Store) και Android (Google Play) με κρατήσεις, check-in, ιστορικό και push notifications.',
        },
        {
          q: 'Τι γίνεται αν ξεπεράσω τα όρια του πλάνου μου;',
          a: 'Θα σε ειδοποιήσουμε με έγκαιρη ειδοποίηση. Μπορείς να αναβαθμίσεις οποτεδήποτε με ένα κλικ.',
        },
        {
          q: 'Παρέχετε εκπαίδευση ή υποστήριξη;',
          a: 'Ναι. Όλα τα πλάνα έχουν email υποστήριξη. Το Pro έχει προτεραιότητα υποστήριξης και onboarding session.',
        },
      ],
    };
  },

  methods: {
    adminNext() { this.adminIdx = (this.adminIdx + 1) % this.adminScreens.length; },
    adminPrev() { this.adminIdx = (this.adminIdx - 1 + this.adminScreens.length) % this.adminScreens.length; },
    handleScroll() {
      this.showMobileCTA = window.scrollY > 600;
    },
  },

  mounted() {
    // Pricing entrance animation
    const section = this.$refs.pricingRef;
    if (section) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.pricingVisible = true;
          observer.disconnect();
          setTimeout(() => { this.pricingAnimated = true; }, 900);
        }
      }, { threshold: 0.15 });
      observer.observe(section);
    }

    // Staggered card animations
    const animateCards = (selector, delayStep = 60) => {
      const cards = this.$el.querySelectorAll(selector);
      if (!cards.length) return;
      const obs = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const idx = [...cards].indexOf(entry.target);
            setTimeout(() => { entry.target.classList.add('card-visible'); }, idx * delayStep);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08 });
      cards.forEach(c => obs.observe(c));
    };
    animateCards('.whom-card', 70);
    animateCards('.feature-card', 40);
    animateCards('.how-card', 100);
    animateCards('.testi-card', 120);
    animateCards('.pain-card', 80);

    // Hero entrance
    this.$nextTick(() => {
      const hc = this.$el.querySelector('.hero-content-enter');
      const hv = this.$el.querySelector('.hero-visual-enter');
      if (hc) setTimeout(() => hc.classList.add('hero-entered'), 50);
      if (hv) setTimeout(() => hv.classList.add('hero-entered'), 200);
    });

    // Sticky mobile CTA
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>


<style scoped>
/* ── Base ── */
.gym-page {
  background: #253649;
  color: #fff;
  overflow-x: hidden;
}

.section {
  padding: clamp(3rem, 6vw, 6rem) 0;
}

.container {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  box-sizing: border-box;
  flex-direction: column;
}

.muted { color: rgba(255,255,255,0.72); overflow-wrap: break-word; word-break: break-word; }

.section-head {
  max-width: 680px;
  margin: 0 auto 2.5rem;
  text-align: center;
}

.section-head h2 {
  font-size: clamp(1.8rem, 2.8vw, 2.4rem);
  font-weight: 900;
  margin: 0.4rem 0 0.6rem;
  overflow-wrap: break-word;
  word-break: break-word;
}

.section-head p {
  font-size: 1.05rem;
  line-height: 1.7;
}

.label-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  border: 1px solid rgba(255,201,71,0.35);
  background: rgba(255,201,71,0.08);
  color: #FFC947;
  border-radius: 999px;
  padding: 0.3rem 0.9rem;
  margin-bottom: 0.6rem;
}

/* ── HERO ── */
.hero {
  margin: 0 auto;
  padding: clamp(2.5rem, 6vw, 6rem) 1.5rem;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 2rem;
  align-items: center;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border: 1px solid rgba(255,201,71,0.3);
  background: rgba(255,201,71,0.07);
  color: #FFC947;
  border-radius: 999px;
  padding: 0.3rem 0.9rem;
  margin-bottom: 1rem;
}

.badge-dot {
  width: 7px; height: 7px;
  border-radius: 50%;
  background: #FFC947;
  box-shadow: 0 0 0 5px rgba(255,201,71,0.15);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { box-shadow: 0 0 0 5px rgba(255,201,71,0.15); }
  50%       { box-shadow: 0 0 0 9px rgba(255,201,71,0.04); }
}

.hero-content h1 {
  font-size: clamp(2.6rem, 4.5vw, 4rem);
  font-weight: 900;
  overflow-wrap: break-word;
  word-break: break-word;
  line-height: 1.2;
  margin: 0 0 1rem;
}

.accent { color: #FFC947; }

.hero-content p {
  font-size: 1.1rem;
  line-height: 1.75;
  color: rgba(255,255,255,0.78);
  margin: 0 0 1.6rem;
}

.hero-cta {
  display: flex;
  gap: 0.8rem;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
}

.cta-primary, .cta-secondary {
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 0.8rem 1.4rem;
  font-weight: 900;
  transition: opacity 0.15s, transform 0.15s;
}

.cta-primary {
  background: #FFC947;
  color: #1a2535;
  border: 1px solid rgba(255,255,255,0.12);
}

.cta-secondary {
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.14);
  color: rgba(255,255,255,0.9);
}

.cta-primary:hover, .cta-secondary:hover { opacity: 0.88; transform: translateY(-1px); }
.cta-primary.big { padding: 0.95rem 1.6rem; }

.hero-trust {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  color: rgba(255,255,255,0.45);
  margin-top: 1rem;
}

.trust-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: rgba(255,255,255,0.8);
  text-decoration: none;
  border: 1px solid rgba(255,255,255,0.14);
  background: rgba(255,255,255,0.05);
  border-radius: 999px;
  padding: 0.25rem 0.7rem;
  font-size: 0.8rem;
  font-weight: 700;
  transition: background 0.15s;
}

.trust-badge:hover { background: rgba(255,255,255,0.10); }

.store-icon { width: 14px; height: 14px; }

.trust-sep { color: rgba(255,255,255,0.25); }

.trust-item {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

.check-icon { width: 13px; height: 13px; color: #4ade80; }

/* Hero visual */
.hero-visual {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.hero-dashboard {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0,0,0,0.55);
  border: 1px solid rgba(255,255,255,0.1);
  background: #1e2e3d;
}

.dashboard-img {
  width: 100%;
  height: auto;
  display: block;
}

.hero-phone-overlay {
  position: absolute;
  bottom: -30px;
  right: -24px;
  width: 220px;
  height: 320px;
  z-index: 2;
}

.phone {
  position: absolute;
  width: 180px;
  border-radius: 22px;
  box-shadow: 0 16px 40px rgba(0,0,0,0.6);
}

.phone-back {
  top: 24px;
  left: 36px;
  opacity: 0.78;
  transform: rotate(6deg) scale(0.96);
  filter: brightness(0.82);
}

.phone-front {
  top: 0;
  left: 0;
  z-index: 1;
  transform: rotate(-3deg);
}

/* ── SHARED FULL-WIDTH SECTION LAYOUT ── */
.sect-head {
  text-align: center;
  max-width: 640px;
  width: 100%;
  margin: 0 auto clamp(1.5rem, 4vw, 3rem);
  padding: clamp(2.5rem, 5vw, 4rem) 1.5rem 0;
  box-sizing: border-box;
}

.sect-head h2 {
  font-size: clamp(1.8rem, 2.8vw, 2.4rem);
  font-weight: 900;
  margin: 0.4rem 0 0.6rem;
  overflow-wrap: break-word;
  word-break: break-word;
}

.sect-head p { font-size: 1.05rem; line-height: 1.7; }

.sect-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  padding: 0 1.5rem clamp(2.5rem, 5vw, 4rem);
  margin-top: clamp(1.5rem, 3vw, 2.5rem);
  box-sizing: border-box;
}

.sect-foot p { margin: 0; font-size: 0.9rem; }

.sect-link {
  flex-shrink: 0;
  text-decoration: none;
  font-weight: 800;
  font-size: 0.9rem;
  color: #FFC947;
  border-bottom: 1px solid rgba(255,201,71,0.4);
  transition: border-color 0.15s;
  white-space: nowrap;
}

.sect-link:hover { border-color: #FFC947; }

/* shared fw-grid cell hover accent */
.whom-card::before,
.how-card::before,
.faq-cell::before {
  content: '';
  position: absolute;
  inset: 0 0 auto 0;
  height: 2px;
  background: #FFC947;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.22s ease;
}

.whom-card:hover,
.how-card:hover,
.faq-cell:hover { background: rgba(255,255,255,0.05); }

.whom-card:hover::before,
.how-card:hover::before,
.faq-cell:hover::before { transform: scaleX(1); }

/* ── FOR WHOM ── */
.whom-section {
  padding: 0;
}

.whom-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid rgba(255,255,255,0.08);
  border-left: 1px solid rgba(255,255,255,0.08);
}

.whom-card {
  position: relative;
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  padding: 2rem 1.6rem;
  border-right: 1px solid rgba(255,255,255,0.08);
  border-bottom: 1px solid rgba(255,255,255,0.08);
  transition: background 0.18s;
  overflow: hidden;
}

.whom-emoji { width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; color: #FFC947; flex-shrink: 0; margin-top: 0.1rem; }
.whom-body { min-width: 0; }
.whom-title { font-weight: 900; font-size: 1rem; margin-bottom: 0.4rem; }
.whom-desc { color: rgba(255,255,255,0.65); font-size: 0.88rem; line-height: 1.6; }

/* ── FEATURES ── */
.features-section {
  background: rgba(31, 45, 61, 0.55);
  padding: 0;
}

.feat-head {
  text-align: center;
  max-width: 640px;
  width: 100%;
  margin: 0 auto clamp(1.5rem, 4vw, 3rem);
  padding: clamp(2.5rem, 5vw, 4rem) 1.5rem 0;
  box-sizing: border-box;
}

.feat-head h2 {
  font-size: clamp(1.8rem, 2.8vw, 2.4rem);
  font-weight: 900;
  margin: 0.4rem 0 0.6rem;
  overflow-wrap: break-word;
  word-break: break-word;
}

.feat-head p { font-size: 1.05rem; line-height: 1.7; }

.features-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid rgba(255,255,255,0.08);
  border-left: 1px solid rgba(255,255,255,0.08);
}

.feature-card {
  position: relative;
  display: flex;
  gap: 0.9rem;
  align-items: flex-start;
  padding: 1.4rem 1.2rem;
  border-right: 1px solid rgba(255,255,255,0.08);
  border-bottom: 1px solid rgba(255,255,255,0.08);
  background: transparent;
  transition: background 0.18s;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  inset: 0 0 auto 0;
  height: 2px;
  background: #FFC947;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.22s ease;
}

.feature-card:hover { background: rgba(255,255,255,0.05); }
.feature-card:hover::before { transform: scaleX(1); }

.feature-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFC947;
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.feature-body { min-width: 0; }
.feature-label { font-weight: 900; font-size: 0.88rem; margin-bottom: 0.25rem; line-height: 1.3; }
.feature-desc { color: rgba(255,255,255,0.58); font-size: 0.78rem; line-height: 1.55; }

.feat-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0 1.5rem clamp(2.5rem, 5vw, 4rem);
  margin-top: clamp(1.5rem, 3vw, 2.5rem);
}

.feat-foot p { margin: 0; font-size: 0.9rem; }

.feat-foot-link {
  flex-shrink: 0;
  text-decoration: none;
  font-weight: 800;
  font-size: 0.9rem;
  color: #FFC947;
  border-bottom: 1px solid rgba(255,201,71,0.4);
  transition: border-color 0.15s;
  white-space: nowrap;
}

.feat-foot-link:hover { border-color: #FFC947; }

/* ── SCREENSHOTS ── */
.screenshots-section { overflow: hidden; }

.screenshots-scroll {
  overflow-x: auto;
  padding: 1.5rem 0;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}

.screenshots-scroll::-webkit-scrollbar { display: none; }

.screenshots-track {
  display: flex;
  gap: 1.2rem;
  padding: 0 max(1.5rem, calc(50vw - 600px));
  width: max-content;
}

.screenshot-item img {
  height: 460px;
  border-radius: 24px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.45);
  display: block;
  transition: transform 0.2s;
}

.screenshot-item img:hover { transform: scale(1.02); }

/* ── Screens tabs ── */
.screens-tabs {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  margin-top: 1.5rem;
}

.screens-tab {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.5rem 1.2rem;
  border-radius: 999px;
  border: 1.5px solid rgba(255,255,255,0.12);
  background: transparent;
  color: rgba(255,255,255,0.5);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.screens-tab:hover { border-color: rgba(255,255,255,0.25); color: rgba(255,255,255,0.8); }

.screens-tab.active {
  background: #F5C842;
  border-color: #F5C842;
  color: #0c1624;
}

/* ── Admin carousel ── */
.admin-carousel {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 0 1.5rem;
  gap: 1.25rem;
}

.carousel-viewport {
  width: 100%;
  max-width: 900px;
  padding: 0 4rem;
  box-sizing: border-box;
}

.carousel-slide {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.carousel-img {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.55);
  border: 1px solid rgba(255,255,255,0.08);
  display: block;
}

.carousel-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: rgba(255,255,255,0.4);
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-60%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1.5px solid rgba(255,255,255,0.15);
  background: rgba(255,255,255,0.05);
  color: rgba(255,255,255,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  z-index: 2;
}

.carousel-arrow:hover { background: rgba(255,255,255,0.12); border-color: rgba(255,255,255,0.3); color: #fff; }

.carousel-arrow--prev { left: calc(50% - 450px + 0.5rem); }
.carousel-arrow--next { right: calc(50% - 450px + 0.5rem); }

.carousel-dots {
  display: flex;
  gap: 0.4rem;
}

.carousel-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border: none;
  background: rgba(255,255,255,0.2);
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
}

.carousel-dot.active { background: #F5C842; transform: scale(1.3); }
.carousel-dot:hover { background: rgba(255,255,255,0.45); }

.carousel-fade-enter-active, .carousel-fade-leave-active { transition: opacity 0.25s ease; }
.carousel-fade-enter-from, .carousel-fade-leave-to { opacity: 0; }

@media (max-width: 768px) {
  .carousel-viewport { padding: 0 3rem; max-width: 100%; }
  .carousel-arrow--prev { left: 0.25rem; }
  .carousel-arrow--next { right: 0.25rem; }
}

.app-store-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1.5rem;
}

.store-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.14);
  color: rgba(255,255,255,0.9);
  font-weight: 800;
  font-size: 0.9rem;
  border-radius: 999px;
  padding: 0.6rem 1.2rem;
  transition: background 0.15s;
}

.store-btn svg { width: 18px; height: 18px; }
.store-btn:hover { background: rgba(255,255,255,0.13); }
.store-note { font-size: 0.82rem; }

/* ── HOW IT WORKS ── */
.how-section {
  padding: 0;
  background: rgba(31, 45, 61, 0.4);
}

.how-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid rgba(255,255,255,0.08);
  border-left: 1px solid rgba(255,255,255,0.08);
}

.how-card {
  position: relative;
  padding: 2.4rem 2rem;
  border-right: 1px solid rgba(255,255,255,0.08);
  border-bottom: 1px solid rgba(255,255,255,0.08);
  transition: background 0.18s;
  overflow: hidden;
}

.step-num {
  font-size: 3rem;
  font-weight: 900;
  color: rgba(255,201,71,0.25);
  line-height: 1;
  margin-bottom: 1rem;
  letter-spacing: -0.02em;
}

.how-card .t { font-weight: 900; font-size: 1.05rem; margin-bottom: 0.4rem; }
.how-card .m { color: rgba(255,255,255,0.65); font-size: 0.9rem; line-height: 1.65; }

/* ── PRICING ── */
.pricing-section {
  padding: 0;
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.2rem;
  align-items: start;
  margin-bottom: 2rem;
}

/* Entrance animation */
.plan-card {
  position: relative;
  border-radius: 20px;
  border: 1px solid rgba(255,255,255,0.1);
  background: rgba(255,255,255,0.04);
  padding: 1.8rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.55s ease,
              transform 0.55s cubic-bezier(0.16, 1, 0.3, 1),
              box-shadow 0.25s ease,
              border-color 0.25s ease;
}

.plans-visible .plan-card {
  opacity: 1;
  transform: translateY(0);
}

.plans-animated .plan-card:hover {
  transform: translateY(-7px);
  box-shadow: 0 24px 48px rgba(0,0,0,0.35);
  border-color: rgba(255,255,255,0.18);
}

.plan-popular {
  border-color: rgba(255,201,71,0.35);
  background: rgba(255,201,71,0.04);
}

.plans-animated .plan-popular:hover {
  border-color: rgba(255,201,71,0.6);
  box-shadow: 0 24px 48px rgba(0,0,0,0.25), 0 0 32px rgba(255,201,71,0.1);
}

.popular-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: #FFC947;
  border: 1px solid rgba(255,201,71,0.3);
  background: rgba(255,201,71,0.08);
  border-radius: 999px;
  padding: 0.25rem 0.75rem;
  margin-bottom: 1rem;
  width: fit-content;
}

.plan-top { margin-bottom: 0.2rem; }
.plan-divider {
  height: 1px;
  background: rgba(255,255,255,0.08);
  margin: 1.2rem 0;
}

.plan-header { margin-bottom: 1.2rem; }

.plan-name-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.plan-icon { display: flex; align-items: center; color: #FFC947; }
.plan-name { font-weight: 900; font-size: 1.1rem; }

.plan-price {
  display: flex;
  align-items: baseline;
  gap: 0.3rem;
  margin-bottom: 0.35rem;
}

.price-val { font-size: 2.4rem; font-weight: 900; line-height: 1; }
.price-per { font-size: 0.85rem; color: rgba(255,255,255,0.55); }
.plan-tagline { font-size: 0.85rem; line-height: 1.5; margin: 0; }

.plan-limits {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.6rem;
  margin-bottom: 1.2rem;
}

.limit-item {
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,0.08);
  background: rgba(255,255,255,0.04);
  padding: 0.55rem 0.75rem;
}

.limit-label { display: block; font-size: 0.68rem; color: rgba(255,255,255,0.5); margin-bottom: 0.2rem; }
.limit-val { font-size: 0.95rem; font-weight: 900; }

.plan-features {
  list-style: none;
  margin: 0 0 1.4rem;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
}

.plan-feat {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  font-size: 0.85rem;
  color: rgba(255,255,255,0.8);
}

.feat-off { color: rgba(255,255,255,0.35); }

.feat-check { display: flex; align-items: center; justify-content: center; width: 18px; flex-shrink: 0; }
.plan-feat:not(.feat-off) .feat-check { color: #4ade80; }
.feat-off .feat-check { color: rgba(255,255,255,0.25); }

.plan-cta-wrap { margin-top: auto; }

.plan-cta {
  display: block;
  text-align: center;
  text-decoration: none;
  border-radius: 12px;
  padding: 0.75rem;
  font-weight: 900;
  font-size: 0.9rem;
  border: 1px solid transparent;
  transition: opacity 0.15s, transform 0.15s;
  margin-bottom: 0.5rem;
}

.plan-cta:hover { opacity: 0.88; transform: translateY(-1px); }

.plan-cta-primary {
  background: rgba(47,85,212,0.9);
  color: #fff;
  border-color: rgba(255,255,255,0.12);
}

.plan-cta-secondary {
  background: rgba(255,255,255,0.07);
  color: rgba(255,255,255,0.8);
  border-color: rgba(255,255,255,0.1);
}

.plan-note { font-size: 0.75rem; text-align: center; margin: 0; }

/* ── Compare table ── */
.compare-wrap { margin-top: 1rem; }

.compare-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 700;
  color: rgba(255,255,255,0.65);
  padding: 0.8rem;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 12px;
  background: rgba(255,255,255,0.03);
  transition: background 0.15s;
  user-select: none;
}

.compare-toggle:hover { background: rgba(255,255,255,0.07); color: #fff; }

.toggle-arrow {
  font-size: 0.65rem;
  transition: transform 0.2s;
}

.toggle-arrow.open { transform: rotate(180deg); }

.compare-table-wrap {
  margin-top: 1rem;
  border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.1);
  overflow: hidden;
  overflow-x: auto;
}

.compare-table {
  width: 100%;
  min-width: 600px;
  border-collapse: collapse;
  font-size: 0.87rem;
}

.compare-table thead th {
  padding: 0.9rem 1.2rem;
  text-align: left;
  font-weight: 900;
  background: rgba(255,255,255,0.04);
  border-bottom: 1px solid rgba(255,255,255,0.08);
}

.th-price {
  font-weight: 900;
  font-size: 0.95rem;
  margin-top: 0.2rem;
}

.th-price span { font-size: 0.72rem; color: rgba(255,255,255,0.5); font-weight: 600; }

.feat-col { width: 40%; }

.col-popular { background: rgba(255,201,71,0.04); }

.section-row td {
  padding: 0.5rem 1.2rem;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.4);
  background: rgba(255,255,255,0.03);
  border-top: 1px solid rgba(255,255,255,0.08);
}

.compare-table tbody tr:not(.section-row):hover { background: rgba(255,255,255,0.03); }

.compare-table tbody tr td {
  padding: 0.75rem 1.2rem;
  border-top: 1px solid rgba(255,255,255,0.06);
}

.row-label { display: block; font-weight: 600; }
.row-hint  { display: block; font-size: 0.72rem; margin-top: 0.1rem; }

.limit-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  min-width: 40px;
  padding: 0 0.7rem;
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.1);
  background: rgba(255,255,255,0.05);
  font-weight: 900;
  font-size: 0.85rem;
}

.cell-yes { color: #4ade80; display: inline-flex; align-items: center; }
.cell-no  { color: rgba(255,255,255,0.25); display: inline-flex; align-items: center; }

/* ── FAQ ── */
.faq-section {
  padding: 0;
  background: rgba(31, 45, 61, 0.4);
}

.faq-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid rgba(255,255,255,0.08);
  border-left: 1px solid rgba(255,255,255,0.08);
}

.faq-cell {
  position: relative;
  padding: 1.8rem 1.6rem;
  border-right: 1px solid rgba(255,255,255,0.08);
  border-bottom: 1px solid rgba(255,255,255,0.08);
  transition: background 0.18s;
  overflow: hidden;
}

.faq-q { font-weight: 900; margin-bottom: 0.55rem; font-size: 0.95rem; line-height: 1.4; }
.faq-a { font-size: 0.86rem; line-height: 1.65; color: rgba(255,255,255,0.65); }

/* ── CTA BOTTOM ── */
.cta-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
}

.cta-inner p  { margin: 0; }

.cta-btns {
  display: flex;
  gap: 0.8rem;
  flex-shrink: 0;
  flex-wrap: wrap;
}

/* ── RESPONSIVE ── */
@media (max-width: 1024px) {
  .features-grid { grid-template-columns: repeat(4, 1fr); }
  .whom-grid { grid-template-columns: repeat(3, 1fr); }
}

@media (max-width: 860px) {
  .hero {
    grid-template-columns: 1fr;
    text-align: center;
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .hero-cta, .hero-trust { justify-content: center; }

  .hero-visual { order: -1; }

  .hero-phone-overlay {
    right: 0;
    bottom: -20px;
    width: 130px;
    height: 220px;
  }

  .phone { width: 105px; }
  .phone-back { left: 44px; top: 24px; }

  .whom-grid { grid-template-columns: 1fr 1fr; }
  .how-grid  { grid-template-columns: 1fr; }
  .faq-grid  { grid-template-columns: 1fr 1fr; }

  .features-grid { grid-template-columns: repeat(3, 1fr); }
  .feat-foot { flex-direction: column; text-align: center; }

  .plans-grid { grid-template-columns: 1fr; gap: 1rem; }

  .sect-foot { flex-direction: column; text-align: center; }

  .cta-inner {
    flex-direction: column;
    text-align: center;
  }

  .cta-btns { justify-content: center; }

  .screenshot-item img { height: 340px; }

  .app-store-row { flex-wrap: wrap; }
}

@media (max-width: 540px) {
  .hero-content h1 { font-size: clamp(1.9rem, 7vw, 2.4rem); }

  .whom-grid { grid-template-columns: 1fr; }
  .faq-grid  { grid-template-columns: 1fr; }
  .features-grid { grid-template-columns: repeat(2, 1fr); }

  .screenshot-item img { height: 280px; }

  .hero-trust { gap: 0.4rem; font-size: 0.78rem; }

  .gym-footer-brand .gym-footer-appstore-btn { display: flex; width: fit-content;}
}

@media (max-width: 400px) {
  .hero-content h1 { font-size: 1.75rem; }
  .features-grid { grid-template-columns: 1fr; }
  .plans-grid { padding: 0 0.25rem; }
  .plan-card { padding: 1.4rem; }
  .phone { width: 95px; }
  .phone-back { left: 28px; }
  .hero-trust { font-size: 0.74rem; }
}

/* ══════════════════════════════════════════
   GYM FOOTER
══════════════════════════════════════════ */
.gym-footer {
  background: #0f1922;
  color: #fff;
  padding: clamp(3rem, 5vw, 4rem) 1.5rem 0;
}

.gym-footer-main {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr;
  gap: 2.5rem 2rem;
  padding-bottom: 3rem;
  border-bottom: 1px solid rgba(255,255,255,0.07);
}

.gym-footer-logo {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.05rem;
  font-weight: 700;
  margin-bottom: 0.9rem;
}

.gym-logo-img{
  width: 38px;
  height: 38px;
}

.gym-footer-logo strong { color: #FFC947; }

.gym-footer-tagline {
  font-size: 0.85rem;
  line-height: 1.6;
  color: rgba(255,255,255,0.55);
  margin: 0 0 1.2rem;
  max-width: 260px;
}

.gym-footer-appstore-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  font-size: 0.85rem;
  font-weight: 800;
  color: #1a2535;
  background: #FFC947;
  border-radius: 999px;
  padding: 0.55rem 1.1rem;
  transition: opacity 0.15s;
  margin-bottom: 0.5rem;
  margin-right: 1rem;
}

.gym-footer-appstore-btn:hover { opacity: 0.88; }

.gym-footer-android {
  font-size: 0.75rem;
  color: rgba(255,255,255,0.35);
  margin: 0.25rem 0 0;
}

.gym-footer-col-title {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.4);
  margin-bottom: 1rem;
}

.gym-footer-col {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.gym-footer-col a,
.gym-footer-col .router-link-active {
  text-decoration: none;
  color: rgba(255,255,255,0.6);
  font-size: 0.88rem;
  transition: color 0.15s;
}

.gym-footer-col a:hover { color: #FFC947; }

.gym-footer-bottom {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.2rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  font-size: 0.8rem;
  color: rgba(255,255,255,0.35);
}

.gym-footer-bottom a,
.gym-footer-bottom .router-link-active {
  color: rgba(255,255,255,0.5);
  text-decoration: none;
  transition: color 0.15s;
}

.gym-footer-bottom a:hover { color: #FFC947; }

.gym-footer-top {
  font-weight: 700;
  font-size: 0.82rem;
}

@media (max-width: 860px) {
  .gym-footer-main {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 540px) {
  .gym-footer-main {
    grid-template-columns: 1fr;
  }

  .gym-footer-bottom {
    flex-direction: column;
    text-align: center;
  }
}

/* ── HERO ENTRANCE ANIMATIONS ── */
.hero-content-enter,
.hero-visual-enter {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.65s ease, transform 0.65s cubic-bezier(0.16, 1, 0.3, 1);
}
.hero-content-enter.hero-entered,
.hero-visual-enter.hero-entered {
  opacity: 1;
  transform: translateY(0);
}

/* ── HERO MICRO-TRUST ── */
.hero-microtrust {
  font-size: 0.8rem;
  color: rgba(255,255,255,0.45);
  margin: 0.6rem 0 0;
  letter-spacing: 0.01em;
}

/* ── PROOF BAR ── */
.proof-bar {
  background: rgba(255,255,255,0.04);
  border-top: 1px solid rgba(255,255,255,0.07);
  border-bottom: 1px solid rgba(255,255,255,0.07);
  padding: 2rem 0;
}
.proof-bar-inner {
  display: flex;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
}
.proof-stat {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
}
.proof-num {
  font-size: 2.8rem;
  font-weight: 900;
  color: #FFC947;
  line-height: 1;
}
.proof-plus { font-size: 1.8rem; }
.proof-label {
  font-size: 0.82rem;
  color: rgba(255,255,255,0.55);
  max-width: 120px;
  line-height: 1.3;
  margin-top: 0.2rem;
}
.proof-divider {
  width: 1px;
  height: 60px;
  background: rgba(255,255,255,0.12);
  flex-shrink: 0;
}
.proof-testimonials {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  flex: 1;
}
.proof-quote {
  flex: 1;
  min-width: 180px;
}
.proof-quote-text {
  font-size: 0.88rem;
  line-height: 1.5;
  color: rgba(255,255,255,0.8);
  font-style: italic;
  margin: 0 0 0.3rem;
}
.proof-quote-author {
  font-size: 0.76rem;
  color: rgba(255,255,255,0.4);
}

/* ── PAIN POINTS ── */
.pain-section {
  padding: 0;
}
.pain-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border-top: 1px solid rgba(255,255,255,0.08);
  border-left: 1px solid rgba(255,255,255,0.08);
}
.pain-card {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  padding: 1.4rem 1.6rem;
  border-right: 1px solid rgba(255,255,255,0.08);
  border-bottom: 1px solid rgba(255,255,255,0.08);
  opacity: 0;
  transform: translateY(16px);
  transition: opacity 0.5s ease, transform 0.5s cubic-bezier(0.16,1,0.3,1), background 0.2s;
}
.pain-card.card-visible {
  opacity: 1;
  transform: translateY(0);
}
.pain-card:hover { background: rgba(255,255,255,0.03); }
.pain-before, .pain-after {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.88rem;
  line-height: 1.5;
  flex: 1;
}
.pain-before { color: rgba(255,255,255,0.5); }
.pain-after { color: rgba(255,255,255,0.9); }
.pain-icon {
  font-size: 0.9rem;
  color: rgba(255,80,80,0.8);
  flex-shrink: 0;
  margin-top: 0.1rem;
}
.pain-icon--green { color: #4ade80; }
.pain-arrow {
  color: #FFC947;
  font-size: 1.1rem;
  flex-shrink: 0;
  margin-top: 0.1rem;
}

/* ── TESTIMONIALS ── */
.testimonials-section {
  background: rgba(31, 45, 61, 0.4);
  padding: 0;
}
.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  border-top: 1px solid rgba(255,255,255,0.08);
  border-left: 1px solid rgba(255,255,255,0.08);
}
.testi-card {
  padding: 1.8rem 1.6rem;
  border-right: 1px solid rgba(255,255,255,0.08);
  border-bottom: 1px solid rgba(255,255,255,0.08);
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.55s ease, transform 0.55s cubic-bezier(0.16,1,0.3,1);
}
.testi-card.card-visible {
  opacity: 1;
  transform: translateY(0);
}
.testi-stars { display: flex; gap: 2px; }
.testi-text {
  font-size: 0.9rem;
  line-height: 1.65;
  color: rgba(255,255,255,0.85);
  flex: 1;
  font-style: italic;
}
.testi-author { display: flex; align-items: center; gap: 0.7rem; }
.testi-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255,201,71,0.15);
  border: 1px solid rgba(255,201,71,0.3);
  color: #FFC947;
  font-weight: 900;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.testi-name { font-weight: 700; font-size: 0.88rem; }
.testi-meta { font-size: 0.78rem; }

/* ── FAQ ACCORDION ── */
.faq-accordion {
  display: flex;
  flex-direction: column;
  border-top: 1px solid rgba(255,255,255,0.08);
}
.faq-item {
  border-bottom: 1px solid rgba(255,255,255,0.08);
  cursor: pointer;
  overflow: hidden;
}
.faq-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem 0;
  gap: 1rem;
}
.faq-header:hover .faq-q { color: #FFC947; }
.faq-chevron {
  flex-shrink: 0;
  transition: transform 0.25s ease;
  color: rgba(255,255,255,0.4);
}
.faq-item.open .faq-chevron { transform: rotate(180deg); color: #FFC947; }
.faq-item.open .faq-q { color: #FFC947; }
.faq-body {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.35s ease, padding 0.35s ease;
}
.faq-item.open .faq-body {
  max-height: 200px;
  padding-bottom: 1rem;
}
.faq-a { font-size: 0.9rem; line-height: 1.7; margin: 0; }

/* ── CARD ANIMATIONS (shared) ── */
.whom-card,
.feature-card,
.how-card {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.5s ease, transform 0.5s cubic-bezier(0.16,1,0.3,1), background 0.18s;
}
.whom-card.card-visible,
.feature-card.card-visible,
.how-card.card-visible {
  opacity: 1;
  transform: translateY(0);
}

/* ── IMPROVED CTA SECTION ── */
.cta {
  padding: 3rem 0;
  background: rgba(47,85,212,0.92);
}
.cta-text {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.cta-proof-line {
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.65);
  margin: 0;
}
.cta-inner h2 {
  font-size: clamp(1.6rem, 3vw, 2.4rem);
  font-weight: 900;
  margin: 0 0 0.4rem;
  overflow-wrap: break-word;
  word-break: break-word;
}

/* ── CTA PULSE ── */
@keyframes ctaPulse {
  0% { box-shadow: 0 0 0 0 rgba(255,201,71,0.45); }
  60% { box-shadow: 0 0 0 14px rgba(255,201,71,0); }
  100% { box-shadow: 0 0 0 0 rgba(255,201,71,0); }
}
.cta-pulse {
  animation: ctaPulse 2.5s ease-out infinite;
}

/* ── STICKY MOBILE CTA ── */
.mobile-cta-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 900;
  padding: 0.8rem 1rem;
  background: #1a2535;
  border-top: 1px solid rgba(255,201,71,0.25);
  display: none;
}
.mobile-cta-btn {
  display: block;
  width: 100%;
  background: #FFC947;
  color: #1a2535;
  text-align: center;
  font-weight: 900;
  font-size: 1rem;
  padding: 0.85rem 1rem;
  border-radius: 999px;
  text-decoration: none;
  transition: opacity 0.15s;
}
.mobile-cta-btn:hover { opacity: 0.9; }
.slide-up-enter-active, .slide-up-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-up-enter-from, .slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

/* ── RESPONSIVE ADDITIONS ── */
@media (max-width: 860px) {
  .proof-bar-inner { flex-direction: column; align-items: flex-start; }
  .proof-divider { width: 60px; height: 1px; }
  .pain-grid { grid-template-columns: 1fr; }
  .testimonials-grid { grid-template-columns: 1fr; }
  .mobile-cta-bar { display: block; }
  .cta-inner { flex-direction: column; text-align: center; gap: 1.5rem; }
  .cta-btns { justify-content: center; }
  .proof-testimonials { flex-direction: column; }
}
@media (max-width: 540px) {
  .pain-grid { grid-template-columns: 1fr; }
}
</style>
